import { erpApi } from "@/shared/axios/erp-api";
import { urlBackend } from "@/shared/constants";
import { DataDashboard } from "@/shared/interfaces";
import { ApiResponse } from "@/shared/interfaces/erp/global/response-axios.interface";
import { handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const { post } = erpApi();

/**
 * 
 * Obtener datos para el dashboard
 * 
 */

export const useFetchGetDashboard = () => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: postDashboard,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['obtener-datos-estadistica'] });
    },
    onError: (error: any) => {
      handleAxiosError(error);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    }
  });
};

export const postDashboard = async (): Promise<ApiResponse<DataDashboard>> => {
  try {
    const resp = await post<DataDashboard>(
      `${urlBackend}api/v1/obtener-datos-estadistica/`, undefined,
      true
    );
    return resp;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
};